import React, {useState} from 'react';
import {FlashMessage} from "../assets/utils";
import api from "../../services/api";

const UpdatePassword = ({onClose}) => {
    const [flashMessage, setFlashMessage] = useState(null);

    const showMessage = (message) => {
        setFlashMessage(message);
    }
    const handleCloseFlashMessage = () => {
        setFlashMessage(null)
    }

    const handleSubmitForm = async (event) => {
        event.preventDefault();

        const password = event.target.elements.password.value;
        const passwordConfirmation = event.target.elements.password_confirmation.value;

        if (password !== passwordConfirmation) {
            showMessage('Passwords do not match')
            return;
        }

        try {
            api.post('/updatePassword', {
                'password': password,
                'password_confirmation': passwordConfirmation
            }).then((response) => {
                showMessage(response.data.message)
            })
        } catch (error) {
            console.error('Failed to update password', error);
        }

    }
    return (
        <>
            {flashMessage && <FlashMessage
                message={flashMessage}
                duration={2000}
                onClose={handleCloseFlashMessage}
            />}
            <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
                <div className="bg-white p-4 rounded-lg shadow-lg max-w-md mx-auto">
                    <form onSubmit={handleSubmitForm}>
                        <label htmlFor="password" className="block text-sm font-medium text-gray-700">Password</label>
                        <input type="password" name="password" id="password"
                               className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"/>

                        <label htmlFor="password_confirmation" className="block text-sm font-medium text-gray-700 mt-4">
                            Repeat Password
                        </label>
                        <input type="password" name="password_confirmation" id="password_confirmation"
                               className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"/>

                        <div className="flex justify-end pt-2 mt-4">
                            <button
                                type="button"
                                className="focus:outline-none px-4 bg-gray-400 p-3 rounded-lg text-black hover:bg-gray-300 mr-2"
                                onClick={onClose}>
                                Close
                            </button>
                            <button
                                type="submit"
                                className="focus:outline-none px-4 bg-blue-500 p-3 rounded-lg text-white hover:bg-indigo-400">
                                Submit
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
};

export default UpdatePassword;